import React, { useMemo } from 'react';
import { Check, ChevronDown } from 'lucide-react';
import useComponentVisible from '../../UI/ComponentVisible';

export const TIMEFRAME_OPTIONS = [
    { key: '4_weeks', label: 'Last 4 weeks' },
    { key: '1_quarter', label: 'Last quarter' },
    { key: '2_quarters', label: 'Last 2 quarters' },
    { key: '4_quarters', label: 'Last 4 quarters' },
];

export const TimeframeDropdown = ({
    selected = '4_quarters',
    onChange,
    options = TIMEFRAME_OPTIONS,
}) => {
    const {
        ref: dropdownRef,
        isComponentVisible: isDropdownOpen,
        setIsComponentVisible: setIsDropdownOpen,
    } = useComponentVisible(false);

    const activeOption = useMemo(
        () => options.find((opt) => opt.key === selected) || options[options.length - 1],
        [options, selected]
    );

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                type="button"
                onClick={() => setIsDropdownOpen((prev) => !prev)}
                aria-expanded={isDropdownOpen}
                aria-haspopup="listbox"
                className="inline-flex items-center gap-1.5 border border-gray-200 rounded-full px-3 py-1 bg-white text-gray-700 text-xs font-medium hover:border-gray-300 hover:bg-gray-50 transition-all cursor-pointer shadow-xs focus:outline-none focus:ring-2 focus:ring-primary/20"
            >
                <span>{activeOption?.label}</span>
                <ChevronDown
                    size={13}
                    className={`text-gray-400 transition-transform duration-150 ${isDropdownOpen ? 'rotate-180 text-primary' : ''}`}
                />
            </button>
            {isDropdownOpen && (
                <div
                    role="listbox"
                    className="stride-dropdown-menu right-0 min-w-[150px]"
                >
                    {options.map((option) => {
                        const isSelected = option.key === selected;
                        return (
                            <button
                                key={option.key}
                                type="button"
                                role="option"
                                aria-selected={isSelected}
                                onClick={() => {
                                    onChange?.(option.key);
                                    setIsDropdownOpen(false);
                                }}
                                className={`stride-dropdown-item ${
                                    isSelected ? 'stride-dropdown-item-active' : ''
                                }`}
                            >
                                <span>{option.label}</span>
                                {isSelected && <Check size={14} className="text-primary ml-2 shrink-0" />}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default TimeframeDropdown;
